import tinycolor from 'tinycolor2';
/**
 * * Using tinycolor2, this function takes a color value (`cssColor`), sets the proper
 * * alpha based on `cssOpacity` and returns the original color value or an RGB color value w/ alpha.
 *
 * ! If tinycolor2 cannot parse `cssColor`, it will be return passed string or `undefined` if falsey.
 */
export const setColorWithOpacityCss = function (cssColor) {
  let cssOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
  const ignoredCssValues = ['inherit', 'transparent'];

  /**
   * return passed `cssColor` if `cssColor` is an ignored CSS value
   */
  if (cssColor && ignoredCssValues.includes(cssColor)) {
    return cssColor;
  }
  const color = tinycolor(cssColor);
  if (!color.isValid()) {
    /**
     * return passed `cssColor`, or undefined if empty
     */
    return cssColor || undefined;
  }
  return color.setAlpha(Number(cssOpacity)).toRgbString();
};